module.exports = __webpack_public_path__ + "assets/media/3.f6cd02af.wav";